import {gql} from 'apollo-angular';


export const personalGql = gql`
query ReloadPersonalQuery($participantId: [Int!]) {
  Participant (participantId: $participantId){
    participantId
    event {
      eventId
    }
    individualConstituent {
      firstName
      lastName
      dateOfBirth
      individualConstituentId
      middleInitial
      suffix
      prefixType {
        cmgmtPrefixTypeId
        name
      }
    }
  }
}
`;